import { BankSettings, Field, Payload } from "../domain/BankSettings"
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher"
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher"
import { query_dispatcher, sync_command_dispatcher } from "@/api/client"

export interface BankRepository {
    find_settings_by_user_id(user_id: number): Promise<any | null>; 
    save(bankSettings): Promise<void>;
    api_to_domain(obj): BankSettings;
}




// REPOSITORIO DE MEMORIA
export class BankMemoryRepository implements BankRepository { 
    private data: BankSettings[]

    constructor(init: {status: string, data:BankSettings[]}) {
        this.data = init.data
    }

    async find_settings_by_user_id(user_id: number): Promise<any | null>  {
        let res = this.data.find(setting => setting.user_id === user_id || null)

        if (res)
            return objectToDict(res)
        return null
    }

    async save(bankSettings: BankSettings): Promise<void> {
        let index = this.data.findIndex(setting => setting.user_id === bankSettings.user_id)
        
        if (index !== -1)
            this.data[index] = bankSettings
        else 
            this.data.push(bankSettings)
    }

    api_to_domain(obj): BankSettings {
        return _api_to_domain(obj)
    }
}


// REPOSITORIO API -DISPATCHER-
export class ApiBankRepository implements BankRepository { 
    query_dispatcher: QueryDispatcher
    sync_command_dispatcher: CommandDispatcher

    constructor() {
        this.query_dispatcher = query_dispatcher
        this.sync_command_dispatcher = sync_command_dispatcher
    }

    async find_settings_by_user_id(user_id: number): Promise<any | null> {
        let args = {
            user_id: user_id,
        };
        
        let res = await this.query_dispatcher.dispatch("get_user_settings", args)
        return res
    }
    
    async save(bankSettings: BankSettings): Promise<void> {
        let args = {settings: objectToDict(bankSettings)}
        await this.sync_command_dispatcher.dispatch("save_user_settings", args)
    }


    api_to_domain(obj) :BankSettings {
        return _api_to_domain(obj)
    }
}


function _api_to_domain(obj): BankSettings {    
    let hide = []
    let show = []

    for(let e in obj['payload']['hide']) {
        let key = obj['payload']['hide'][e]['key']
        let text = obj['payload']['hide'][e]['text']
        let come_from = obj['payload']['hide'][e]['come_from']

        hide.push(new Field(key, text, come_from))
    }
    
    for(let e in obj['payload']['show']) {
        let key = obj['payload']['show'][e]['key']
        let text = obj['payload']['show'][e]['text']
        let come_from = obj['payload']['show'][e]['come_from']

        show.push(new Field(key, text, come_from))
    }
    let payload = new Payload(hide, show)
    let domain = new BankSettings(obj.id, obj.code, payload, obj.user_id)

    return domain
}



function objectToDict(obj: any): Record<string, any> {
    const dict: Record<string, any> = {};

    for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            const value = obj[key];
            if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
                // Recursively convert nested object
                dict[key] = objectToDict(value);
            } else {
                dict[key] = value;
            }
        }
    }
    return dict;
}



